export const mainBarSubMenus = {
  moduleName: "Main Bar",
  subModules: {
    "Point-of-sales": [],
    // "Folios",
    Orders: [],
    Tables: [],
    // "Backtrack",
    Sales: ["Receipts", "Shift", "Daily", "Items Sold"],
    "Guests In-House": ["Individual", "Group"],
    "Kitchen Orders": [],
    "Current Stocks": [],
    Stocks: [],
  },
};
export const poolBarSubMenus = {
  moduleName: "Pool Bar",
  subModules: mainBarSubMenus.subModules,
};
export const restaurantSubMenus = {
  moduleName: "Restaurant",
  subModules: mainBarSubMenus.subModules,
};

export const kitchenSidebarNavlinks = [
  "Queued Orders",
  "Preparing Orders",
  "Daily Discharged Orders",
  "Shift Discharged Orders",
  "Guests In-House",
  "Stocks",
];

export const storeSubMenus = {
  moduleName: "Store",
  subModules: {
    Sections: [],
    Items: [],
    Records: ["Items", "Outlets"],
    Outlets: [],
    Logs: [],
  },
};

export const reservationsSubMenus = {
  moduleName: "Reservations",
  subModules: {
    "New Reservation": ["Group", "Individual"],
    "Reservation Table": ["Group", "Individual"],
    Schedules: [
      "Calendar",
      "Future Individual Arrivals",
      "Future Group Arrivals",
      "Future Occupancies",
    ],
    "Room status": [],
    Receipts: [],
    Profiles: [],
  },
};

export const recordsSidebarNavlinks = {
  moduleName: "Records",
  subModules: {
    // "Guest Ledger",
    // "Guest In-house",
    // "Guest Bills",
    "Guests In-House": [],
    "Financial Transactions": [],
    Charges: [],
    Credits: [],
    // "City Ledger": [],
    // "Room Discrepancy": [],
    "Daily Managers' Flash": [],
    "Weekly Managers' Flash": [],
    "Trial Balance": [],
    // "Monthly Report": [],
    // "Aging Analysis": [],
    // "Folios": [],
    Deposits: [],
    Receipts: [],
    "Cashiers Summary Report": [],
    "Cashiers Breakdown Report": [],
    "System Transactions": [],
    // "F&B Revenues": [],
    "F&B Sales Ledger": [],
    "Front-office Ledger": [],
    "Market Count Segmentation": [],
    "Market Worth Segmentation": [],
    "Room-Type Count Segmentation": [],
    "Room-Type Worth Segmentation": [],
    // "Restaurant Daily Sales": [],
    // "Bar Daily Sales": [],
    // "Pool-Bar Daily Sales": [],
    "Daily Logs": [],
  },
};
export const reportsSidebarNavlinksSubMenu = {
  "Guest Ledger": ["Group", "Individual"],
  "Guest In-house": ["Group", "Individual"],
  // "Guest Bills": ["Group", "Individual"],
  "City Ledger": ["Group", "Individual"],
  "Checkout History": [],
  "Credit Balance": ["Group", "Individual"],
  "Financial Transactions": [],
  // "Rate Variance": [],
  // "Room Discrepancy": [],
  "Managers' Flash": [],
  // "Trial Balance": [],
  "PM Account": [],
  "Aging Analysis": [],
  Deposits: [],
  "Cashiers Report": [],
  Receipts: [],
  // "History": [],
  // "End Of Day": [],
};

export const frontdeskSubMenus = {
  moduleName: "Frontdesk",
  subModules: {
    Arrivals: ["Group", "Individual"],
    "Checked-in": ["Group", "Individual"],
    Departures: ["Group", "Individual"],
    // "Checked-out": ["Group", "Individual"],
    "Security & Auditor Report": [],
    // "Guest Bills": ['Group', "Individual"],
    "PM Account": ["Checked-Out", "In-House", "Debt Ledger"],
    "Room Details": ["Room Status", "Room-type Summary"],
    Facilities: ["Facility", "Events"],
    // History: [],
    // "House Account": [],
    "End Of Day": [],
  },
};

export const settingsSubMenus = {
  moduleName: "Settings",
  subModules: {
    Charges: [
      "Frontdesk Charges",
      "F and B Charges",
      "F and B Discounts",
      "Taxes",
      "Payment Method",
    ],
    Credits: ["Frontdesk Credits", "F and B Credits"],
    "Inventory Management": [
      "Major Group",
      "Family Group",
      "Menu Items",
      "F and B Tables",
      "F and B Time",
    ],
    "User Management": ["Users", "Shifts", "Shift timing"],
    "User Activities": ["User Logs"],
    "Group Management": ["Groups", "Group Rate", "Membership Type"],
    "Room Settings": [
      "Room Floor",
      "Room Type",
      "Room and Rates",
      "Room Status",
      "Bar Rates",
      "Rate Name",
      "Rate Type",
      // "Schedule Rates"
    ],
    "Other Setups": ["Title", "Source", "Hotel Date", "Communications"],
    // 'Other Setups': ['Title', 'Source', 'Hotel Date', 'Permissions', 'Communications', 'Non-Occupied Rooms', 'Virtual Orders'],
    "PM Account": ["Checked-Out", "In-House"],
    // Facilities: [''],
    // "Table Management": [],
    Companies: [],
    Licenses: [],
  },
};

export const houseKeepingNavlinks = {
  moduleName: "House Keeping",
  subModules: {
    "Room Status": [],
    "Room-type Summary": [],
    Stocks: [],
  },
};

export const backTrackSubMenus = {
  moduleName: "Backtrack",
  subModules: {
    Accommodation: ["Group", "Individual"],
    Guests: ["Group", "Individual"],
    "PM Account": [],
    Restaurant: [],
    "Pool Bar": [],
    Bar: [],
    Facilities: ["Facility", "Events"],
    "No EOD": [],
  },
};

export const accountsSubMenus = {
  moduleName: "Accounts",
  subModules: {
    "Checked-in": ["Individual", "Group"],
    "PM Account": ["Checked-out", "In-House"],
    "Debt Ledger": [],
    Receivables: [],
    "Aging Analysis": [],
    History: [],
  },
};

export const statisticsSubMenus = {
  moduleName: "Statistics",
  subModules: {
    "Managers-Flash": [],
    "Market-Segments": [],
    Rates: [],
    Guests: [],
    "F&B": [],
  },
};

// export const  = ['Daily Audit Count', 'Monthly Averages', 'Department Averages'];

// interface HandleMenuInterface {
//     state: any
//     stateSetter: Function
//     toggledLink: string
// }
// export const handleSubMenus = (props: HandleMenuInterface) => {
//     props.state.toggleMenuState[props.toggledLink] = !props.state.toggleMenuState[props.toggledLink];
//     Object.keys(props.state.toggleMenuState).map(link => {
//         if(link !== props.toggledLink){
//             props.state.toggleMenuState[link] = props.state.toggleMenuState[link] ? !props.state.toggleMenuState[link] : props.state.toggleMenuState[link];
//         }
//     });
//     props.stateSetter({...props.state});
// };
